import type { CrmObject } from '../../core/types';
import { getEntityTypeConfig } from '../registry/entityTypeRegistry';
import { MeetingNotesSummaryPanel } from './MeetingNotesSummaryPanel';
import { ResearchSummaryPanel } from './ResearchSummaryPanel';

export function AISummaryPanel({ object }: { object: CrmObject }) {
  const source =
    getEntityTypeConfig(object.entity_type_name).aiSummarySource ?? 'none';
  if (source === 'research') {
    return <ResearchSummaryPanel object={object} />;
  }
  if (source === 'meeting_notes') {
    return <MeetingNotesSummaryPanel object={object} />;
  }
  return null;
}
